import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import { useGetOperationListQuery, useGetWorkstationListQuery } from "../../../../store/api/bomapi";

const OperationRight = ({ setselected_operation_data, po_status,checkbox }) => {
  const createNewRow = () => ({
    operation: "",
    operation_data: {},
    workstation_type: "",
    workstation_data: {},
    operation_time: 1,
    operating_cost: "0",
  });

  const tableRef = useRef();
  const dropdownRef = useRef();
  const [rowsPerPage] = useState(10);
  const [operation_list, setOperation_list] = useState([]);
  const [workstation_list, setWorkstation_list] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([createNewRow()]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [search_input, setsearch_input] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
  const {data:OperationData} = useGetOperationListQuery();
  const {data:WorkstationData} = useGetWorkstationListQuery();


  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = rows.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };
  
  const filterOperations = (searchText = "") => {
    if (!OperationData?.data) return [];
    return OperationData.data.filter(item => 
      item.name.toLowerCase().includes(searchText.toLowerCase()) ||
      item.description.toLowerCase().includes(searchText.toLowerCase())
    );
  };

  const filterWorkstations = (searchText = "") => {
    if (!WorkstationData?.data) return [];
    return WorkstationData.data.filter(item => 
      item.workstation_name.toLowerCase().includes(searchText.toLowerCase()) ||
      item.workstation_type.toLowerCase().includes(searchText.toLowerCase())
    );
  };

  const updateRow = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    
    if (field === "operation_time") {
      const time = parseFloat(updatedRows[index].operation_time) || 0;
      let cost = 0;
      if (updatedRows[index].workstation_data?.hour_rate) {
        cost = time * parseFloat(updatedRows[index].workstation_data.hour_rate);
      }
      updatedRows[index].operating_cost = cost.toFixed(0);
    } else if (field === "workstation_data") {
      const time = parseFloat(updatedRows[index].operation_time) || 0;
      const cost = time * parseFloat(value.hour_rate || 0);
      updatedRows[index].operating_cost = cost.toFixed(0);
    }
    
    setRows(updatedRows);
    setselected_operation_data(updatedRows);
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) => 
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    setselected_operation_data(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) {
      setCurrentPage(lastPage);
    }
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    setselected_operation_data(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  useEffect(() => {
    if (OperationData?.data) {
      setOperation_list(OperationData.data);
    }
    if (WorkstationData?.data) {
      setWorkstation_list(WorkstationData.data);
    }
  }, [OperationData?.data, WorkstationData?.data]);

  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th");
    if (!cols) return;
    
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    !checkbox.withOperations ? '' : <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {["Action", "S.No", "Operation", "Workstation", "Operation Time (mins)", "Operating Cost"].map((title, i) => {
              const defaultWidths = {
                "Action": "20px",
                "S.No": "20px",
                "Operation": "220px",
                "Workstation": "220px",
                "Operation Time (mins)": "120px",
                "Operating Cost": "120px",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: '7px',
                    position: "relative",
                    textAlign: title === "Action" || title === "S.No" ? "center" : "center",
                    width: defaultWidths[title] || "150px",
                    minWidth: defaultWidths[title] || "150px",
                  }}
                >
                  {title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{ 
                        backgroundColor: isAllSelected ? "#270b79" : "", 
                        borderColor: isAllSelected ? "#270b79" : "", 
                        fontSize: '15px' 
                      }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  ) : (
                    title
                  )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                <td className="p-0" style={{ cursor: 'pointer' }}>
                  <p className="m-0" style={{ position: 'relative', top: "5px" }}>
                    {selectedRows.includes(globalIndex) ? (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ 
                            backgroundColor: "#270b79", 
                            fontSize: '15px', 
                            borderColor: '#270b79' 
                            
                          }}
                          checked
                        />
                      </span>
                    ) : (
                      <span onClick={() => toggleRowSelection(globalIndex)}>
                        <input 
                          type="checkbox" 
                          className="form-check-input" 
                          style={{ fontSize: '15px' }} 
                        />
                      </span>
                    )}
                  </p>
                </td>
                <td style={{
                  textAlign: "center",
                  fontSize: '0.8rem',
                  padding: '0.5rem'
                }}>
                  {globalIndex + 1}
                </td>
                
                {/* Operation Field */}
                <td 
    className="p-0 d-flex" 
    style={{ 
      position: "relative", 
      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'operation' ? '0.3px solid #270b79' : '' 
    }}
  >
    <div className="d-flex justify-content-center" style={{width:'100%'}}>
      <input
        type="text"
        className="form-control tableinput noborder"
        style={{ fontSize: '0.8rem',width:'100%' }}
        onFocus={() => { 
          setShowDropdown(`operation_${globalIndex}`); 
          setFocusedCell({ rowIndex: globalIndex, field: 'operation' });
          if (!row.operation && !row.operation_data.name) {
            setsearch_input("");
            setOperation_list(OperationData?.data || []);
          }
        }}
        onBlur={() => setTimeout(() => setShowDropdown(false), 300)}
        onChange={(e) => {
          setsearch_input(e.target.value);
          const filteredItems = filterOperations(e.target.value);
          setOperation_list(filteredItems);
          updateRow(globalIndex, "operation", e.target.value);
        }}
        value={row.operation_data.name || row.operation}
      />
    </div>
    {showDropdown === `operation_${globalIndex}` && (
      <div
        ref={dropdownRef}
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          maxHeight: "200px",
          overflowY: "auto",
          background: "white",
          border: "1px solid #ccc",
          zIndex: 10,
        }}
      >
        {operation_list.length > 0 ? (
          operation_list.map((item, idx) => (
            <div 
              key={idx}
              className="text-start"
              onClick={() => {
                updateRow(globalIndex, "operation_data", item);
                updateRow(globalIndex, "operation", item.name);
                setsearch_input("");
                setShowDropdown(false);
              }}
              style={{
                padding: "8px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
              }}
            >
              <p className="m-0">{item.name}</p>
            </div>
          ))
        ) : (
          <div style={{ padding: "8px", color: "#888" }}>No results found</div>
        )}
      </div>
    )}
  </td>
                
                {/* Workstation Type Field */}



                <td 
    className="p-0" 
    style={{ 
      position: "relative", 
      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'workstation_type' ? '0.3px solid #270b79' : '' 
    }}
  >
    <div className="d-flex justify-content-center">
      <input
        type="text"
        className="form-control tableinput noborder"
        style={{ fontSize: '0.8rem' }}
        onFocus={() => { 
                      setShowDropdown(`workstation_${globalIndex}`); 
                      setFocusedCell({ rowIndex: globalIndex, field: 'workstation_type' });
                      if (!row.workstation_type && !row.workstation_data.workstation_type) {
                        setsearch_input("");
                        setWorkstation_list(WorkstationData?.data || []);
                      }
                    }}
                    onBlur={() => setTimeout(() => setShowDropdown(false), 300)}
                    onChange={(e) => {
                      setsearch_input(e.target.value);
                      const filteredItems = filterWorkstations(e.target.value);
                      setWorkstation_list(filteredItems);
                      updateRow(globalIndex, "workstation_type", e.target.value);
                    }}
                    value={row.workstation_data.workstation_type || row.workstation_type}
                  
      />
    </div>
     {showDropdown === `workstation_${globalIndex}` && (
                    <div
                      ref={dropdownRef}
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: "200px",
                        overflowY: "auto",
                        background: "white",
                        border: "1px solid #ccc",
                        zIndex: 10,
                      }}
                    >
                      {workstation_list.length > 0 ? (
                        workstation_list.map((item, idx) => (
                          <div 
                            key={idx}
                            className="text-start"
                            onClick={() => {
                              updateRow(globalIndex, "workstation_data", item);
                              updateRow(globalIndex, "workstation_type", item.name);
                              setsearch_input("");
                              setShowDropdown(false);
                            }}
                            style={{
                              padding: "8px",
                              cursor: "pointer",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                    
                            <p className="m-0">{item.name}</p>
                          </div>
                        ))
                      ) : (
                        <div style={{ padding: "8px", color: "#888" }}>No results found</div>
                      )}
                    </div>
                  )}
  </td>


  
                
                {/* Operation Time Field */}
                <td className="p-0 d-flex justify-content-center" 
                    style={{ 
                      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'operation_time' ? '0.3px solid #270b79' : '' 
                    }}
                >
                  <input 
                    type="number" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem' }} 
                    min={0.1} 
                    step={0.1}
                    onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: 'operation_time' })}
                    onBlur={() => setFocusedCell({ rowIndex: null, field: null })} 
                    value={row.operation_time} 
                    onChange={(e) => {
                      const value = parseFloat(e.target.value);
                      if (value >= 0.1 || e.target.value === '') {
                        updateRow(globalIndex, "operation_time", e.target.value);
                      }
                    }} 
                  />
                </td>
                
                {/* Operating Cost Field */}
                <td className="p-0">
                  <input 
                    type="text" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem' }} 
                    readOnly 
                    value={row.operating_cost ? `₹${row.operating_cost}` : "₹0.00"} 
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
          {selectedRows.length > 0 && po_status === '' && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn"
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}
          {selectedRows.length === 0 && po_status === '' && (
            <Button
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{ 
                backgroundColor: '#ff8d5c', 
                padding: '1px', 
                display: 'flex' 
              }}
            >
              Add Row
            </Button>
          )}
          <Button
            className="createbtn d-flex"
            style={{ gap: '2px', height: '28px' }}
            iconName="MdOutlineFileDownload"
            iconSize={12}
          >
            Download
          </Button>
        </div>

        {rows.length >= 11 && (
          <>
            <div className="d-flex align-items-center centerpagination" style={{ gap: '5px' }}>
              <Pagination
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                pageSize={rowsPerPage}
                totalrecords={rows.length}
              />
            </div>
            <div>
              <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
                Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OperationRight;